import { fruits, scaleGuide } from "@/data/fruits";

export const FruitRatingList = ({ ratings, onRatingChange }) => (
  <section className="space-y-5" data-testid="reflection-fruit-section">
    {fruits.map((fruit, index) => (
      <article key={fruit.key} className="gentle-reveal rounded-2xl border border-[#E5E1D8] bg-white p-5 shadow-[0_8px_30px_rgba(26,54,38,0.04)] sm:p-7" style={{ animationDelay: `${index * 55}ms` }} data-testid={`reflection-fruit-${fruit.key}`}>
        <div className="grid gap-5 lg:grid-cols-[0.8fr_1.2fr] lg:items-center">
          <div>
            <h2 className="font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid={`reflection-fruit-${fruit.key}-title`}>{fruit.label}</h2>
            <p className="mt-2 text-sm leading-relaxed text-[#4A5D4E]" data-testid={`reflection-fruit-${fruit.key}-prompt`}>{fruit.prompt}</p>
          </div>
          <div className="grid grid-cols-5 gap-2" data-testid={`reflection-fruit-${fruit.key}-scale`}>
            {[1, 2, 3, 4, 5].map((value) => (
              <button
                key={value}
                type="button"
                onClick={() => onRatingChange(fruit.key, value)}
                data-testid={`reflection-fruit-${fruit.key}-rating-${value}-button`}
                className={`aspect-square rounded-2xl border text-lg font-semibold transition-[background-color,color,transform,border-color] duration-300 hover:-translate-y-1 ${ratings[fruit.key] === value ? "border-[#C87961] bg-[#C87961] text-white" : "border-[#E5E1D8] bg-[#F9F6F0] text-[#4A5D4E] hover:border-[#C87961]"}`}
              >
                {value}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-2 text-xs text-[#8C9B90] sm:grid-cols-3 lg:col-start-2" data-testid={`reflection-fruit-${fruit.key}-scale-hints`}>
            <span data-testid={`reflection-fruit-${fruit.key}-scale-hint-low`}>1 — {scaleGuide[0].label}</span>
            <span data-testid={`reflection-fruit-${fruit.key}-scale-hint-mid`}>3 — {scaleGuide[2].label}</span>
            <span data-testid={`reflection-fruit-${fruit.key}-scale-hint-high`}>5 — {scaleGuide[4].label}</span>
          </div>
        </div>
      </article>
    ))}
  </section>
);